export enum SessionFlow {
  UPDATE = 'subscription_update',
  CANCEL = 'subscription_cancel',
}
